import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Col, Row, Button } from 'twyne-new.ui';

import ObjectModal from '@Components/modals/ObjectModal';
import { formatDateTime } from '@Utils/index';
import MetaFieldsResult from './MetaFieldsResult';
import { formatBool, formatMoney, getUrlLink, CardTitle } from './utils';
import PathSessionResult from './PathSessionResult';

import store from '../../../stores/inquiry'
import IntegrationResult from './IntegrationResult';
import { Card, Property } from '@/components/reports/card';

export default function UserSessionResult({ data }) {
  const ButtonOpenModal = ({ handleToggle }) => <Col size='2'>
    <Button variant='light' color='accent' onClick={handleToggle}>
      more details
    </Button>
  </Col>

  const UserSessionDetails = ({ session }) => <>
    <Row>
      <Property label="Created At" value={formatDateTime(session.created_at)} />
      <Property label="Updated At" value={formatDateTime(session.updated_at)} />
      <Property label="User session uuid" value={session.usessionid} />
      <Property label="Allocation Id" value={
        <Link to={`${getUrlLink('allocation')}/${session.allocationId}`}>
          {store.allocation.objectsMapping[session.allocationId]?.getLabel() || session.allocationId}
        </Link>
      } />
      <Property label="publisherId" value={
        <Link to={`${getUrlLink('publisher')}/${session.publisherId}`}>
          {store.publisher.objectsMapping[session.publisherId]?.getLabel() || session.publisherId}
        </Link>
      } />
      <Property label="SID 1" value={session.sid1} />
      <Property label="Conversion Type" value={session.conversiontype} />
      <Property label="Converted" value={formatBool(session.converted)} />
      <Property label="Registration Completed" value={formatBool(session.registrationCompleted)} />
      <Property label="TCPA Consent" value={formatBool(session.tcpaconsent)} />
      <Property label="External ID" value={session.externalid} />
      <Property label="Payout Type" value={session.payouttype} />
      <Property label="Recording Consent" value={formatBool(session.recording_consent)} />
      <Property label="Revenue" value={formatMoney(session.revenue)} />
    </Row>
    <Row className="mb-3">
      <ObjectModal id="registration-modal" button={ButtonOpenModal} title="Registration Data" data={Object.entries(session || {})} />
    </Row>
  </>

  return data.map(session => <Card key={session.id} title={<CardTitle title={`User Session Id: ${session.id}`} />}>
    <UserSessionDetails session={session} />
    <MetaFieldsResult data={session.metaFields} />
    <PathSessionResult data={session.pathSessions} />
    <IntegrationResult data={session.integrations} />
  </Card>,
  )
}

const propTypes = { data: PropTypes.array }
UserSessionResult.propTypes = propTypes
UserSessionResult.defaultProps = { data: [] }